import PropTypes from 'prop-types';
import { notification } from 'antd';

export const openNotification = (title, message, type, position, duration) => {
  notification[type]({
    message: title,
    description: message,
    placement: position,
    duration: duration || 5,
  });
};

openNotification.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  position: PropTypes.string,
  duration: PropTypes.number,
  response: PropTypes.any,
};

openNotification.defaultProps = {
  // title: null,
  // message: null,
  // type: 'info',
  // position: 'bottomRight',
  // duration: 5,
  // response: null,
};
